import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import { GetSingleLayanan, reset } from "../../../features/LayananSlice";
import {
  GetAllDokumenLoss,
  reset as resetDokumen,
} from "../../../features/DokumenSlice";
import {
  GetAllLayananDokumenByLayananID,
  reset as resetLayananDokumen,
} from "../../../features/layananDokumenSlice";

import {
  Card,
  Button,
  Form,
  Col,
  Row,
  Table,
  ButtonGroup,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleLeft,
  faPencilAlt,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";

import BASE_URL from "../../../api";
import { reset as resetKodePay, GetAllKodePayDropdown } from '../../../features/kodepayVASlice';
import { reset as resetLayananKodePay, GetAllLayananKodePayByLayananID } from "../../../features/layananKodepay";
import ModalCollectibleList from "../../../components/modal/ModalCollectibleList";

const FormLayananPage = () => {
  const [newData, setNewData] = useState({
    kode: "",
    nama: "",
    deskripsi: "",
  });
  const [showModalKodePay, setShowModalKodePay] = useState(false);

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector((state) => state.layanan);
  const { data: dataLayananDokumen, isLoading: isLoadingLayananDokumen } =
    useSelector((state) => state.layananDokumen);
  const { data: dataLayananKodePay, isLoading: isLoadingLayananKodePay } =
    useSelector((state) => state.layananKodepay);
  const { data: dataDokumen, isLoading: isLoadingMasterDokumen } = useSelector(
    (state) => state.dokumen
  );
  const { data: dataKodePay, isLoading: isLoadingMasterKodePay } = useSelector(
    (state) => state.kodepayVA
  );

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(reset());
    dispatch(resetDokumen());
    dispatch(resetKodePay());
    dispatch(resetLayananDokumen());
    dispatch(resetLayananKodePay());

    // fetch data.
    if (id) {
      fetchData();
    }
  }, [id, dispatch, token]);

  function fetchData() {
    dispatch(reset());
    dispatch(resetDokumen());
    dispatch(resetKodePay());
    dispatch(resetLayananDokumen());
    dispatch(resetLayananKodePay());

    dispatch(GetAllKodePayDropdown(token));
    dispatch(GetAllDokumenLoss({ token }));
    dispatch(GetSingleLayanan({ id, token }));
    dispatch(GetAllLayananDokumenByLayananID({ id, token }));
    dispatch(GetAllLayananKodePayByLayananID({ id, token }));
  }

  useEffect(() => {
    setNewData({
      kode: data?.data?.kode,
      nama: data?.data?.nama,
      deskripsi: data?.data?.deskripsi,
    });
  }, [data]);

  const onClickCheckMasterDokumen = (checked, idLayananDokumen) => {
    showAlertDialog({
      title: "Update?",
      msg: `apakah anda yakin ingin mengupdate data ini?`,
      confirmButtonText: "Update",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          response = await axios.put(
            `${BASE_URL}master/layanan_dokumen/${idLayananDokumen}`,
            {
              is_mandatory: checked,
            },
            {
              headers: {
                Authorization: token,
              },
            }
          );
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          fetchData();
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const onClickCheckMasterKodePay = (checked, idLayananKodePay) => {
    showAlertDialog({
      title: "Update?",
      msg: `apakah anda yakin ingin mengupdate data ini?`,
      confirmButtonText: "Update",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          response = await axios.put(
            `${BASE_URL}master/layanan_kodepay/${idLayananKodePay}`,
            {
              is_must_current_pay: checked,
            },
            {
              headers: {
                Authorization: token,
              },
            }
          );
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          fetchData();
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const onClickAddMasterDokumen = (idDokumen) => {
    showAlertDialog({
      title: "Tambah?",
      msg: `apakah anda yakin ingin menambah data ini?`,
      confirmButtonText: "Tambah",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          response = await axios.post(
            `${BASE_URL}master/layanan_dokumen`,
            {
              id_layanan: id,
              id_dokumen: idDokumen,
              is_mandatory: true,
            },
            {
              headers: {
                Authorization: token,
              },
            }
          );
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          fetchData();
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const onClickAddMasterKodePay = (item) => {
    showAlertDialog({
      title: "Tambah?",
      msg: `apakah anda yakin ingin menambah data ini?`,
      confirmButtonText: "Tambah",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          const body = [];
          if (Array.isArray(item)) {
            for (let i = 0; i < item.length; i++) {
              const e = item[i];
              body.push({
                id_layanan: id,
                kode_pay: e.kode,
                is_must_current_pay: true,
              });
            }
          } else {
            body = [{
              id_layanan: id,
              kode_pay: item.kode,
              is_must_current_pay: true,
            }];
          }
          const response = await axios.post(
            `${BASE_URL}master/layanan_kodepay`,
            body,
            {
              headers: {
                Authorization: token,
              },
            }
          );
          console.log("RESPONSE : ", response);
          // close the modal
          setShowModalKodePay(false);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          fetchData();
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const onClickDeleteMasterDokumen = (idLayananDokumen) => {
    showAlertDialog({
      title: "Hapus?",
      msg: `apakah anda yakin ingin menghapus data ini?`,
      confirmButtonText: "Hapus",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          response = await axios.delete(
            `${BASE_URL}master/layanan_dokumen/${idLayananDokumen}`,
            {
              headers: {
                Authorization: token,
              },
            }
          );
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          fetchData();
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const onClickDeleteMasterKodePay = (idLayananKodePay) => {
    showAlertDialog({
      title: "Hapus?",
      msg: `apakah anda yakin ingin menghapus data ini?`,
      confirmButtonText: "Hapus",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          response = await axios.delete(
            `${BASE_URL}master/layanan_kodepay/${idLayananKodePay}`,
            {
              headers: {
                Authorization: token,
              },
            }
          );
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          fetchData();
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    showAlertDialog({
      title: id ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        id ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: id ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.put(
              `${BASE_URL}master/layanan/${id}`,
              {
                ...newData,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}master/layanan`,
              {
                ...newData,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          navigate("/master/layanan/list");
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[3] === "view" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/layanan/edit/${id}`}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="me-2" />
              Edit
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "add" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/layanan/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "edit" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/layanan/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          id={id}
          newData={newData}
          setNewData={setNewData}
          isLoading={isLoading}
          isLocked={param.pathname.split("/")[3] === "view" || isLoading}
          // modal
          showModalKodePay={showModalKodePay}
          setShowModalKodePay={setShowModalKodePay}
          // layanan dokumen
          isLoadingMasterDokumen={isLoadingMasterDokumen}
          dataDokumen={dataDokumen}
          isLoadingLayananDokumen={isLoadingLayananDokumen}
          dataLayananDokumen={dataLayananDokumen}
          onClickCheckMasterDokumen={onClickCheckMasterDokumen}
          onClickAddMasterDokumen={onClickAddMasterDokumen}
          onClickDeleteLayananDokumen={onClickDeleteMasterDokumen}
          // layanan kodepay
          isLoadingMasterKodePay={isLoadingMasterKodePay}
          dataKodePay={dataKodePay}
          isLoadingLayananKodePay={isLoadingLayananKodePay}
          dataLayananKodePay={dataLayananKodePay}
          onClickCheckMasterKodePay={onClickCheckMasterKodePay}
          onClickAddMasterKodePay={onClickAddMasterKodePay}
          onClickDeleteLayananKodePay={onClickDeleteMasterKodePay}
          handleSubmit={handleSubmit}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  newData,
  setNewData,
  id,
  isLocked = false,
  isLoading = false,
  handleSubmit,
  // modal
  showModalKodePay,
  setShowModalKodePay,
  // layanan dokumen
  isLoadingMasterDokumen,
  dataDokumen,
  isLoadingLayananDokumen,
  dataLayananDokumen,
  onClickAddMasterDokumen,
  onClickCheckMasterDokumen,
  onClickDeleteLayananDokumen,
  // layanan kode pay
  isLoadingMasterKodePay,
  dataKodePay,
  isLoadingLayananKodePay,
  dataLayananKodePay,
  onClickAddMasterKodePay,
  onClickCheckMasterKodePay,
  onClickDeleteLayananKodePay,
}) => {

  // edit dokumen list, remove the data if it is already have it
  const editedDataDokumen = () => {
    return dataDokumen?.data?.filter((el) => {
      return !dataLayananDokumen?.data
        ?.map((item) => item.id_dokumen)
        ?.includes(el.id);
    });
  };
  
  // edit kode pay list, remove the data if it is already have it
  const editedDataKodePay = () => {
    const result = dataKodePay?.data?.filter((el) => {
      return !dataLayananKodePay?.data
        ?.map((item) => item.kode_pay)
        ?.includes(el.kode);
    });
    return result;
  };

  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group id="kode">
                <Form.Label>Kode</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Kode"
                  name="kode"
                  disabled={isLocked}
                  value={newData.kode || ""}
                  onChange={(e) =>
                    setNewData({ ...newData, kode: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="Nama">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Nama"
                  name="nama"
                  disabled={isLocked}
                  value={newData.nama || ""}
                  onChange={(e) =>
                    setNewData({ ...newData, nama: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="deskripsi">
                <Form.Label>Deskripsi</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Deskripsi"
                  name="nama"
                  disabled={isLocked}
                  value={newData.deskripsi || ""}
                  onChange={(e) =>
                    setNewData({ ...newData, deskripsi: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          {/* List Master Dokumen */}
          {id && isLocked ? (
            <>
              <hr data-content="Master Dokumen" className="hr-text" />
              <Row>
                <Col xl={7} md={12} className="mb-3">
                  <Table
                    responsive
                    striped
                    className="table-centered table-nowrap rounded mb-0"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th className="border-0">#</th>
                        <th className="border-0">Nama Dokumen</th>
                        <th className="border-0">Mandatory?</th>
                        <th className="border-0">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingLayananDokumen ? (
                        <tr>
                          <th colSpan="4" style={{ textAlign: "center" }}>
                            Loading...
                          </th>
                        </tr>
                      ) : (dataLayananDokumen?.data || []).length > 0 ? (
                        dataLayananDokumen?.data?.map((item, i) => (
                          <tr key={i}>
                            <th>{i + 1}</th>
                            <th>{item.nama_dokumen}</th>
                            <th style={{ textAlign: "center" }}>
                              <Form.Check
                                type="checkbox"
                                checked={item.is_mandatory}
                                onChange={(evt) =>
                                  onClickCheckMasterDokumen(
                                    evt.target.checked,
                                    item.id
                                  )
                                }
                              />
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <ButtonGroup size="sm">
                                <Button
                                  variant="danger"
                                  onClick={() => onClickDeleteLayananDokumen(item.id)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                              </ButtonGroup>
                            </th>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <th colSpan="4" style={{ textAlign: "center" }}>
                            Tidak ada data!
                          </th>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
                <Col xl={5} md={12} className="mb-3">
                  <Table
                    responsive
                    striped
                    className="table-centered table-nowrap rounded mb-0"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th className="border-0">#</th>
                        <th className="border-0">Nama Dokumen</th>
                        <th className="border-0">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingMasterDokumen ? (
                        <tr>
                          <th colSpan="3" style={{ textAlign: "center" }}>
                            Loading...
                          </th>
                        </tr>
                      ) : (editedDataDokumen() || []).length > 0 ? (
                        editedDataDokumen()?.map((item, i) => (
                          <tr key={i}>
                            <th>{i + 1}</th>
                            <th>{item.nama}</th>
                            <th style={{ textAlign: "center" }}>
                              <ButtonGroup size="sm">
                                <Button
                                  onClick={() =>
                                    onClickAddMasterDokumen(item.id)
                                  }
                                >
                                  <FontAwesomeIcon icon={faPlus} />
                                </Button>
                              </ButtonGroup>
                            </th>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <th colSpan="3" style={{ textAlign: "center" }}>
                            Tidak ada data!
                          </th>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </>
          ) : null}
          {/* List Master Kodepay */}
          {id && isLocked ? (
            <>
              <hr data-content="Master Kode Payment" className="hr-text" />
              <Row>
                <Col md={12} className="mb-3">
                  <Table
                    responsive
                    striped
                    className="table-centered table-nowrap rounded mb-0"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th className="border-0">#</th>
                        <th className="border-0">Kode</th>
                        <th className="border-0">Nama</th>
                        <th className="border-0">Cek Periode?</th>
                        <th className="border-0">{
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={() => setShowModalKodePay(true)}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </Button>
                        }</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingLayananKodePay ? (
                        <tr>
                          <th colSpan="5" style={{ textAlign: "center" }}>
                            Loading...
                          </th>
                        </tr>
                      ) : (dataLayananKodePay?.data || []).length > 0 ? (
                        dataLayananKodePay?.data?.map((item, i) => (
                          <tr key={i}>
                            <th>{i + 1}</th>
                            <th>{item.kode_pay}</th>
                            <th>{item.nama_pembayaran}</th>
                            <th style={{ textAlign: "center" }}>
                              <Form.Check
                                type="checkbox"
                                checked={item.is_must_current_pay}
                                onChange={(evt) =>
                                  onClickCheckMasterKodePay(
                                    evt.target.checked,
                                    item.id
                                  )
                                }
                              />
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <ButtonGroup size="sm">
                                <Button
                                  variant="danger"
                                  onClick={() => onClickDeleteLayananKodePay(item.id)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                              </ButtonGroup>
                            </th>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <th colSpan="7" style={{ textAlign: "center" }}>
                            Tidak ada data!
                          </th>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <ModalCollectibleList
                    show={showModalKodePay}
                    id="kode"
                    handleClose={() => setShowModalKodePay(false)}
                    filteredItemsCb={(item, searchTerm) => item?.deskripsi?.concat(" ", item?.kode).toLowerCase()?.includes(searchTerm?.toLowerCase())}
                    items={editedDataKodePay()}
                    buildItem={(item) => (
                      <>
                        <div className="fw-bold">{item.kode}</div>
                        <div>{item.deskripsi}&nbsp;({item.periode_mulai || "2019"})</div>
                      </>
                    )}
                    onSubmit={(result) => onClickAddMasterKodePay(result)}
                  />
                </Col>
                {/* <Col xl={5} md={12} className="mb-3">
                  <Table
                    responsive
                    striped
                    className="table-centered table-nowrap rounded mb-0"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th className="border-0">#</th>
                        <th className="border-0">Kode</th>
                        <th className="border-0">Nama</th>
                        <th className="border-0">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingMasterKodePay ? (
                        <tr>
                          <th colSpan="4" style={{ textAlign: "center" }}>
                            Loading...
                          </th>
                        </tr>
                      ) : (editedDataKodePay() || []).length > 0 ? (
                        editedDataKodePay()?.map((item, i) => (
                          <tr key={i}>
                            <th>{i + 1}</th>
                            <th>{item.kode}</th>
                            <th>{item.deskripsi}</th>
                            <th style={{ textAlign: "center" }}>
                              <ButtonGroup size="sm">
                                <Button
                                  onClick={() =>
                                    onClickAddMasterKodePay(item.id)
                                  }
                                >
                                  <FontAwesomeIcon icon={faPlus} />
                                </Button>
                              </ButtonGroup>
                            </th>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <th colSpan="4" style={{ textAlign: "center" }}>
                            Tidak ada data!
                          </th>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col> */}
              </Row>
            </>
          ) : null}
          <div>
            {!isLocked ? (
              <Button type="submit">{id ? "Update" : "Simpan"}</Button>
            ) : null}
          </div>
        </Form>
      )}
    </Card.Body>
  );
};

export default FormLayananPage;
